export default __webpack_public_path__ + "static/media/1640_start.83069c17.webp";